module.exports = __webpack_public_path__ + "static/media/img-mystery-box.c26b4b54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Header/Box/img-mystery-box.svg
// module id = 421
// module chunks = 0